import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

// UI State Atoms
export const isMobileAtom = atom(false);
export const isFullWidthAtom = atom(window.innerWidth >= 1024);
export const appLoadedAtom = atom(false);

// Font State Atom (persisted in localStorage)
export const selectedFontAtom = atomWithStorage("selectedFont", "Nunito");
